import { XBoldIcon } from '@/icons';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { cn } from '@/utils';
import { useEditMode } from '../../focus/useIsEditMode';
import { QuizImage } from '../QuizImage';
export const EditableQuestionImage = ({
  imageUrl,
  isUploading,
  onRemove
}: {
  imageUrl?: string;
  isUploading: boolean;
  onRemove?: () => void;
}) => {
  const {
    isEditMode,
    onEditModeChange
  } = useEditMode();
  if (!imageUrl && !isUploading) return null;
  return <div className={cn('group relative flex h-[156px] w-full cursor-pointer items-center justify-center rounded-sm border border-opacity-assistive bg-neutral p-sm', 'mb-2xs')} onClick={e => {
    e.stopPropagation();
    onEditModeChange(true);
  }} data-sentry-component="EditableQuestionImage" data-sentry-source-file="EditableQuestionImage.tsx">
      {isUploading ? <QuizImage.Loading /> : <div className="relative flex items-center justify-center">
          {isEditMode && <QuizImage.RemoveButton className={cn('shadow-xs')} onClick={() => onRemove?.()}>
              <XBoldIcon width={14} height={14} className="[&>*]:fill-white" />
            </QuizImage.RemoveButton>}
          <QuizImage.Container onClick={() => {
        imageUrl && imageDetailModal.open(imageUrl);
      }}>
            <QuizImage.Thumbnail className="h-full max-h-[132px] w-full max-w-[578px] object-contain" onMouseDown={e => {
          e.stopPropagation();
          e.preventDefault();
        }} src={imageUrl} alt="question-image" />
          </QuizImage.Container>
        </div>}
    </div>;
};